import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.to-string';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _getIterator from '@babel/runtime-corejs3/core-js/get-iterator';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import bemCnFast from '@webteam/bem-cn-fast';
import { withTheme } from '@webteam/ui-contexts';
import { optionType, optionGroupType, noOptionsMessageType } from '../common-prop-types.js';
import SelectTrigger from './trigger.js';
import FormikTriggerWrapper from './formik-trigger-wrapper.js';
import localNames from './native-select.module.pcss.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o) { if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var bemCn = bemCnFast('wt-native-select', localNames);
var DEFAULT_NO_OPTIONS_MESSAGES = {
  noOptions: 'No options',
  loading: 'Loading...'
}; // eslint-disable-next-line complexity

function NativeSelect(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      theme = _ref.theme,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      style = _ref.style,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? {
    label: ''
  } : _ref$defaultValue,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? undefined : _ref$value,
      onChange = _ref.onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Placeholder' : _ref$placeholder,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      trigger = _ref.trigger,
      label = _ref.label,
      note = _ref.note,
      error = _ref.error,
      noOptionsMessage = _ref.noOptionsMessage,
      dataTest = _ref['data-test'];

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var displayed = value ? value : selected;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hovered = _useState4[0],
      setHovered = _useState4[1];

  function handleChange(event) {
    var newValue = event.target.value;
    var selectedOption = findSelectedOption(options, newValue);
    setSelected(selectedOption);

    if (onChange) {
      onChange(selectedOption);
    }
  }

  var optionList;

  if (containsGroups(options)) {
    optionList = _mapInstanceProperty(options).call(options, renderOptionGroup);
  } else {
    optionList = _mapInstanceProperty(options).call(options, renderOption);
  }

  var placeholderOption = {
    value: '__placeholder__',
    label: options.length > 0 ? placeholder : getNoOptionsMessage(noOptionsMessage, isLoading),
    disabled: true
  };

  if (placeholder !== null) {
    optionList.unshift(renderOption(placeholderOption));
  }

  var _trigger;

  if (trigger) {
    _trigger = trigger({
      selectedLabel: displayed.label,
      selectedValue: displayed.value,
      placeholder: placeholder,
      hovered: hovered
    });
  } else {
    _trigger = React.createElement(SelectTrigger, {
      theme: theme,
      size: size,
      isOpen: false,
      onKeyDown: function onKeyDown() {
        return false;
      },
      selected: displayed,
      placeholder: placeholder,
      searchInput: "",
      isClearable: false,
      isLoading: isLoading,
      isDisabled: isDisabled,
      error: Boolean(error)
    });
  }

  return React.createElement(FormikTriggerWrapper, {
    className: className,
    theme: theme,
    size: size,
    error: error,
    label: label,
    note: note,
    "data-test": dataTest
  }, React.createElement("div", {
    className: bemCn(),
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    style: style,
    "data-test": "native-select"
  }, _trigger, React.createElement("select", {
    "data-test": "native-select_select",
    className: bemCn('select', {
      size: size
    }),
    disabled: isDisabled ? true : undefined,
    onChange: handleChange,
    value: displayed.label !== '' ? displayed.value : placeholderOption.value
  }, optionList)));
}

NativeSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.arrayOf(optionType), PropTypes.arrayOf(optionGroupType)]),
  defaultValue: optionType,
  value: optionType,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['m', 's', 'xs']),
  theme: PropTypes.oneOf(['light', 'dark']),
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  trigger: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  label: PropTypes.node,
  note: PropTypes.node,
  noOptionsMessage: noOptionsMessageType,
  style: PropTypes.object,
  'data-test': PropTypes.string
};

function getOptionValue(option) {
  return typeof option.value === 'string' ? option.value : option.label;
}

function isString(s) {
  return Object.prototype.toString.call(s) === '[object String]';
}

function containsGroups(opts) {
  return opts.length > 0 && opts[0].options && _Array$isArray(opts[0].options);
} // eslint-disable-next-line react/prop-types


function renderOptionGroup(_ref2, index) {
  var _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label;
  return React.createElement("optgroup", {
    key: index,
    label: label
  }, _mapInstanceProperty(options).call(options, renderOption));
}

function renderOption(option) {
  var optionProps = {
    key: getOptionValue(option),
    value: getOptionValue(option)
  };

  if (option.disabled) {
    optionProps.disabled = true;
  }

  return React.createElement("option", _extends({
    key: getOptionValue(option)
  }, optionProps), option.label);
}

function findSelectedOption(options, selectedValue) {
  if (containsGroups(options)) {
    var result;

    var _iterator = _createForOfIteratorHelper(options),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _context;

        var group = _step.value;
        result = _findInstanceProperty(_context = group.options).call(_context, function (o) {
          return getOptionValue(o) === selectedValue;
        });
        if (result) return result;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  } else {
    return _findInstanceProperty(options).call(options, function (o) {
      return getOptionValue(o) === selectedValue;
    }) || null;
  }
}

function getNoOptionsMessage(noOptionsMessage, isLoading) {
  var _ref3 = isString(noOptionsMessage) ? _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), {}, {
    noOptions: noOptionsMessage
  }) : _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), noOptionsMessage),
      noOptions = _ref3.noOptions,
      loading = _ref3.loading;

  if (isLoading) {
    return loading;
  } else {
    return noOptions;
  }
}

var nativeSelect = withTheme(NativeSelect);

export { nativeSelect as default };
